/* ---------------------------------------------------------------------
   Sierra Hotel — Add-to-Cart behavior  [round-4 #11]
   Add to cart WITHOUT navigating to /cart or opening a drawer:
   intercept the product form submit, add via AJAX, update the header
   cart count, and flip the button label to "Added to cart" briefly.
   Runs in the capture phase so it pre-empts the theme's native submit.
   --------------------------------------------------------------------- */
(function () {
  function isAddForm(form) {
    return form && form.matches && form.matches('[data-product-form], form[action$="/cart/add"]');
  }

  function updateCartCount(count) {
    // Update the number itself (the theme's count span), NOT the wrapper —
    // writing to the wrapper would delete this span, which the theme's own
    // cart JS looks up by [data-js-cart-count].
    document.querySelectorAll('[data-js-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    // Make sure the indicator bubble is visible when there are items.
    document.querySelectorAll('.header__cart-count, [data-js-cart-indicator]').forEach(function (el) {
      el.classList.remove('hidden', 'is-empty');
      if (count > 0) el.style.removeProperty('display');
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAddForm(form)) return;

    // Take over: no native submit, no other submit handlers.
    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('[data-add-to-cart]')
      || form.querySelector('.product-form__cart-submit')
      || form.querySelector('[type="submit"]');
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;
    var labelEl = btn ? (btn.querySelector('[data-add-to-cart-text]') || btn) : null;

    var fd = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        // let any theme listeners know the cart changed
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

        if (labelEl && btn) {
          if (btn.__origLabel == null) btn.__origLabel = labelEl.textContent;
          labelEl.textContent = 'Added to cart';
          btn.classList.add('is-added');
          clearTimeout(btn.__revertTimer);
          btn.__revertTimer = setTimeout(function () {
            labelEl.textContent = btn.__origLabel;
            btn.classList.remove('is-added');
          }, 2200);
        }
      })
      .catch(function (err) {
        // Never navigate away — surface a short message on the button instead.
        console.error('[custom-cart] add failed', err);
        if (labelEl && btn) {
          if (btn.__origLabel == null) btn.__origLabel = labelEl.textContent;
          var msg = (err && (err.description || err.message)) || 'Unable to add';
          labelEl.textContent = msg.length > 24 ? 'Unavailable' : msg;
          btn.classList.add('is-error');
          clearTimeout(btn.__revertTimer);
          btn.__revertTimer = setTimeout(function () {
            labelEl.textContent = btn.__origLabel;
            btn.classList.remove('is-error');
          }, 2600);
        }
      });
  }, true);
})();

/* ---------------------------------------------------------------------
   Collection card image swipe on mobile  [round-4 #7, option A]
   Swipe left/right on a product card image to cross-fade between its two
   images. A tap still opens the product (we only block the click when the
   gesture was actually a swipe). Touch-only + mobile width gated.
   --------------------------------------------------------------------- */
(function () {
  var THRESHOLD = 40;
  document.addEventListener('touchstart', function (e) {
    var media = e.target.closest && e.target.closest('.product-item__media--multiple-images');
    if (!media) return;
    var t = e.touches[0];
    media.__sx = t.clientX;
    media.__sy = t.clientY;
    media.__swiped = false;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var media = e.target.closest && e.target.closest('.product-item__media--multiple-images');
    if (!media || media.__sx == null) return;
    var t = e.changedTouches[0];
    var dx = t.clientX - media.__sx;
    var dy = t.clientY - media.__sy;
    media.__sx = null;
    if (window.innerWidth >= 750) return;
    if (Math.abs(dx) < THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return; // not a horizontal swipe
    media.__swiped = true;
    if (dx < 0) media.classList.add('is-showing-two');   // swipe left → second image
    else media.classList.remove('is-showing-two');       // swipe right → first image
  }, { passive: true });

  // If the gesture was a swipe (not a tap), don't follow the card link.
  document.addEventListener('click', function (e) {
    var media = e.target.closest && e.target.closest('.product-item__media--multiple-images');
    if (media && media.__swiped) {
      e.preventDefault();
      e.stopPropagation();
      media.__swiped = false;
    }
  }, true);
})();

/* ---------------------------------------------------------------------
   Product "SOLD OUT" label below the price — keep it in sync with the
   selected variant's availability (mirrors the add-to-cart button state).
   [round-5 #5]
   --------------------------------------------------------------------- */
(function () {
  var label = document.querySelector('[data-sold-out-label]');
  var btn = document.querySelector('.product-form__cart-submit');
  if (!label || !btn) return;
  function sync() {
    var soldOut = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
    label.hidden = !soldOut;
  }
  new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[name^="options"], [name="id"]')) {
      setTimeout(sync, 80);
    }
  });
  sync();
})();

/* ---------------------------------------------------------------------
   Filter / Sort drawer — make "Clear all" actually apply  [round-5 follow-up]
   The theme's Clear-all handler only unchecks the inputs inside the drawer;
   it never re-runs the query, so the products and URL don't change and it
   looks broken. After the theme unchecks, commit the cleared state by
   triggering the sibling Apply button in the same panel (which refetches
   and closes the drawer) — the same result the user gets by hitting Apply.
   --------------------------------------------------------------------- */
(function () {
  document.addEventListener('click', function (e) {
    var clearBtn = e.target.closest && e.target.closest('[data-button="clear-all"]');
    if (!clearBtn) return;
    var panel = clearBtn.closest('.filter-drawer__panel')
      || clearBtn.closest('.filter-drawer__footer')
      || document;
    // Let the theme's own handler finish unchecking first, then commit.
    setTimeout(function () {
      var apply = panel.querySelector('[data-button="apply"]');
      if (apply) apply.click();
    }, 0);
  });
})();
